"use client"

import type { Post } from "@/sanity.types"
import { css, fmobile, fresponsive, ftablet, styled } from "library/styled"
import { useMemo, useState } from "react"
import Pagination from "./Pagination"
import { SmallCard } from "./SmallCard"

export function PostList({
	posts,
	resultsPerPage = 10,
}: {
	posts: Post[]
	resultsPerPage?: number
}) {
	const [activePage, setActivePageAction] = useState(1)

	const validPosts = posts.filter((post) => post !== null && post !== undefined)

	const paginatedPosts = useMemo(() => {
		const startIndex = (activePage - 1) * resultsPerPage
		const endIndex = startIndex + resultsPerPage
		return validPosts.slice(startIndex, endIndex)
	}, [validPosts, activePage, resultsPerPage])

	return (
		<>
			<Wrapper>
				{paginatedPosts.map((post) => (
					<SmallCard key={post._id} post={post} />
				))}
			</Wrapper>
			{validPosts.length > resultsPerPage && (
				<Pagination
					totalElements={validPosts.length}
					setActivePage={setActivePageAction}
					activePage={activePage}
					resultsPerPage={resultsPerPage}
					scrollTarget="scroll-target"
				/>
			)}
		</>
	)
}

const Wrapper = styled("div", {
	...fresponsive(css`
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: 24px;
	`),

	...ftablet(css`
		grid-template-columns: repeat(2, 1fr);
	`),

	...fmobile(css`
		grid-template-columns: repeat(1, 1fr);
		place-items: center;
	`),
})
